import i18n from 'i18next'

const es = i18n.getFixedT('es')
const ca = i18n.getFixedT('ca')

const getMultiLanguagesPaths = (URLComponents: Object) => {
  let resultPathCa: string = ca(URLComponents.path)
  let resultPathEs: string = es(URLComponents.path)

  if (URLComponents.pathLocations) {
    URLComponents.pathLocations.forEach((pathLocation: Object) => {
      resultPathCa = resultPathCa.replace(pathLocation.location, ca(pathLocation.replacer))
      resultPathEs = resultPathEs.replace(pathLocation.location, es(pathLocation.replacer))
    })
  }
  return {
    ca: resultPathCa,
    es: resultPathEs
  }
}

export default getMultiLanguagesPaths
